export default __webpack_public_path__ + "static/media/Raging Storm - Forming Storm.90e8c221.png";